import { CustomFieldDefinition, CustomFieldType } from '__types__';
import { FilterConfigBase } from 'v5/patterns/filters/FilterWidget.types';
import { createBooleanFilterConfig } from './boolean';
import { createDateFilterConfig } from './date';
import { createEnumFilterConfig } from './enum';
import { createFallbackFilterConfig } from './fallback';
import { createNumberFilterConfig } from './number';
import { createStringFilterConfig } from './string';
import { TFunction } from 'i18next';

export function createCustomFieldFilterConfig(
  customFieldDef: CustomFieldDefinition,
  t: TFunction<'core'>
): FilterConfigBase {
  switch (customFieldDef.data_type) {
    case CustomFieldType.SHORT_TEXT:
    case CustomFieldType.LONG_TEXT:
    case CustomFieldType.URL:
      return createStringFilterConfig(customFieldDef);

    case CustomFieldType.PERCENTAGE:
    case CustomFieldType.NUMBER:
    case CustomFieldType.CURRENCY:
    case CustomFieldType.MEASUREMENT:
    case CustomFieldType.MEASUREMENT_NEW:
      return createNumberFilterConfig(customFieldDef);

    case CustomFieldType.BOOLEAN:
      return createBooleanFilterConfig(customFieldDef);

    case CustomFieldType.SINGLE_SELECT:
    case CustomFieldType.MULTI_SELECT:
      return createEnumFilterConfig(customFieldDef);

    case CustomFieldType.DATE:
    case CustomFieldType.DATE_RANGE:
      return createDateFilterConfig(customFieldDef, t);

    default:
      return createFallbackFilterConfig(customFieldDef);
  }
}
